<template>
  <div v-loading="loading" class="upload">
    <div v-for="(item, index) in documents" :key="item.id">
      <FIleList
        :title="`${index + 1}. ${
          item.documentType[`name${$t('message.lan')}`]
        }`"
        :document="item"
        :documentType="item.documentType || {}"
        :application="application"
        :serviceType="serviceType"
      ></FIleList>
    </div>

    <div class="next_btn">
      <GradientBtn @click="next" :loading="submitLoading">{{
        $t("message.check_and_submit")
      }}</GradientBtn>
    </div>
  </div>
</template>

<script>
import GradientBtn from "../../../components/GradientBtn";
import HzmbApplicationAPI from "../../../api/HzmbApplicationAPI";
import FIleList from "./FIleList";
import ApplicationAPI from "@/api/ApplicationAPI";
import { applicationTypeFilter } from "@/filters";
import HzmbVehDriApplicationChangeAPI from "@/api/HzmbVehDriApplicationChangeAPI";
export default {
  components: { GradientBtn, FIleList },
  data() {
    return {
      documents: [],
      serviceType: this.$route.query.serviceType || null,
      spNo: this.$route.query.spNo || null,
      changeType: this.$route.query.changeType || null,
      loading: false,
      submitLoading: false,
      application: {},
    };
  },
  computed: {
    // documentType: {
    //   get() {
    //     return this.$store.state.documentType;
    //   },
    //   set(value) {
    //     this.$store.commit("changeDocumentType", value);
    //   },
    // },
    apiType() {
      const serviceType = localStorage.getItem("serviceType") || null;
      switch (serviceType) {
        case "DRV_LIC_INTER":
          return "/driving";
        case "HZMB_CHANGE_PERSON":
        case "HZMB_CHANGE_COMP":
        case "HZMB_GH_CHANGE_COMP":
          return "/change";
        default:
          return "";
      }
    },
  },
  methods: {
    // handleChange(file, id) {
    //   this.documents = this.documents.map((item) => {
    //     if (item.id == id) {
    //       item.afterFile = file;
    //     }
    //     return item;
    //   });
    // },
    // // 移除文件
    // removeFile(id) {
    //   this.documents = this.documents.map((item) => {
    //     if (item.id == id) {
    //       delete item.afterFile;
    //     }
    //     return item;
    //   });
    // },
    next() {
      this.$confirm(
        this.$t("message.confirm_submit_content"),
        this.$t("message.tips"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(async () => {
          // 驗證必填項
          const documents = this.documents;
          let isCheck = true;
          for (let i in documents) {
            if (!documents[i].document) {
              isCheck = false;
            }
          }
          // console.log(isCheck);
          if (!isCheck) {
            this.$message({
              type: "error",
              message: this.$t("message.upload_required"),
            });
            return false;
          }

          const { serviceType, id } = this.application;
          this.submitLoading = true;
          try {
            if (
              [
                "HZMB_CHANGE_PERSON",
                "HZMB_CHANGE_COMP",
                "HZMB_GH_CHANGE_COMP",
              ].includes(serviceType)
            ) {
              await HzmbVehDriApplicationChangeAPI.supplement(serviceType, id);
            } else {
              await HzmbApplicationAPI.supplement(serviceType, id);
            }
            this.$message({
              message: this.$t("message.submit_success"),
              type: "success",
            });
            this.$router.push("/search/status");
          } catch (error) {
            this.$error(error);
          } finally {
            this.submitLoading = false;
          }
        })
        .catch(() => {
          return;
        });
    },
  },
  async created() {
    const spNo = this.spNo;
    this.spNo = spNo;
    const serviceType = this.serviceType;
    const changeType = this.changeType;
    if (!spNo) return false;
    try {
      this.loading = true;
      const apiType = this.apiType;
      const simpleData = await ApplicationAPI.getBySpNo(serviceType, spNo, apiType, changeType);
      const { applicationNo, id } = simpleData;
      // 判斷查詢編號
      if (!applicationNo) {
        this.$message({
          message: this.$t("message.search_spNo_error"),
          type: "error",
        });
        return false;
      }
      let application = null;
      if (
        [
          "HZMB_CHANGE_PERSON",
          "HZMB_CHANGE_COMP",
          "HZMB_GH_CHANGE_COMP",
        ].includes(serviceType)
      ) {
        const { documents, hzmbVehDriChangeApplication, supplementDocuments } =
          await HzmbVehDriApplicationChangeAPI.findById(simpleData.id);
        application = {
          ...hzmbVehDriChangeApplication,
          documents,
          supplementDocuments,
        };
      } else {
        if (applicationTypeFilter(simpleData.serviceType) === "FIRST") {
          application = await HzmbApplicationAPI.firstSearch(id);
        }
        if (applicationTypeFilter(simpleData.serviceType) === "RENEW") {
          application = await HzmbApplicationAPI.renewSearch(id);
        }
      }

      this.application = application;
      let supplementDocuments = [];
      for (let i in application.supplementDocuments) {
        let ele = application.supplementDocuments[i];
        const files = application.documents.filter(
          (f) => f.documentType.id === ele.documentType.id
        );
        if (files.length > 0) {
          const file = files[0];
          ele.document = file;
          ele.documentType.file = {
            uid: "-1",
            name: file.file && file.file.filename,
            size: file.file && file.file.fileSize,
            status: "ready",
          };
        }
        supplementDocuments.push(ele);
      }
      this.documents = supplementDocuments;
    } catch (error) {
      this.$error(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.upload {
  max-width: 690px;
  margin: 24px auto;
  background: #fff;
  overflow: hidden;
}

.verification_content {
  background: #fff;
}
.gradient_btn {
  width: 300px;
  max-width: 100%;
}
.gradient_btn_pt {
  width: 400px;
}
</style>